import { useEffect } from 'react';
import { brand } from '@/config/brand';

/**
 * ThemeProvider - Applies brand theme colors to the document root as CSS variables.
 * Colors are defined statically in src/config/brand.ts.
 */
export const ThemeProvider = () => {
  useEffect(() => {
    applyThemeColors(brand.colors);
  }, []);

  return null;
};

function hexToRgb(hex: string): string {
  const cleanHex = hex.replace(/^#/, '');
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);
  return `${r} ${g} ${b}`;
}

function applyThemeColors(colors: { primary: string; secondary: string; accent: string }) {
  const root = document.documentElement;
  root.style.setProperty('--color-primary', colors.primary);
  root.style.setProperty('--color-primary-rgb', hexToRgb(colors.primary));
  root.style.setProperty('--color-secondary', colors.secondary);
  root.style.setProperty('--color-secondary-rgb', hexToRgb(colors.secondary));
  root.style.setProperty('--color-accent', colors.accent);
  root.style.setProperty('--color-accent-rgb', hexToRgb(colors.accent));
}
